import DashboardWrapper from "components/lib/Global/DashboardWrapper";
import EmbeddedClientSigning from "components/EmbeddedClientSigning";

const EmbeddedClientSigningPage = () => {
  return (
    <DashboardWrapper>
      <EmbeddedClientSigning />
    </DashboardWrapper>
  );
};

export default EmbeddedClientSigningPage;
